import { Outlet } from 'react-router-dom'

const LayoutStart = () => {     
    return (
        <Outlet />
    )
}

export default LayoutStart